// Shared santri schema — used by AdminDashboard modal, table & SantriDashboard profile

export const PENDIDIKAN_OPTIONS = [
  "TK atau Sederajat",
  "SD atau Sederajat",
  "SMP atau Sederajat",
  "SMA atau Sederajat",
  "D1",
  "D2",
  "D3",
  "D4",
  "S1",
  "S2",
  "S3",
  "Tidak Sekolah",
];

export const STATUS_SANTRI_OPTIONS = [
  "Santri Aktif",
  "Santri Aktif & Khatam 30 Juz",
  "Santri Aktif & Selesai Tasmi 30 Juz",
  "Keluar & Khatam 30 Juz",
  "Keluar & Tasmi 30 Juz",
  "Keluar Belum Selesai 30 Juz",
  "DO (Drop Out)",
];

export const STATUS_PENGABDIAN_OPTIONS = [
  "Sedang Pengabdian",
  "Selesai Pengabdian",
  "Belum Pengabdian",
  "Diganti dengan Infaq Produktif",
];

export const KONDISI_PENYAKIT_OPTIONS = ["Tidak Ada", "Sembuh", "Kambuhan"];

export const GOL_DARAH_OPTIONS = ["A", "B", "AB", "O", "Tidak Tahu"];

export const JK_OPTIONS = ["Ikhwan", "Akhwat"];

// Field descriptors: { key, label, type, options?, group, quickFill?, hideFromSantri? }
// type: text | textarea | date | select | phone | currency | year
export const SEGMENTS = [
  {
    id: "biodata",
    label: "Biodata Santri",
    fields: [
      { key: "username", label: "Username (ID)", type: "text", required: true, group: "biodata" },
      { key: "password", label: "Password", type: "text", required: true, group: "biodata" },
      { key: "nama_santri", label: "Nama Lengkap Santri", type: "text", group: "biodata" },
      { key: "tanggal_masuk_grq", label: "Tanggal Masuk GRQ", type: "date", group: "biodata" },
      // tahun_masuk_grq is auto-derived; shown read-only
      { key: "tahun_masuk_grq", label: "Tahun Masuk GRQ", type: "computed", group: "biodata" },
      { key: "daerah_asal", label: "Daerah Asal", type: "text", group: "biodata" },
      { key: "status_santri", label: "Status Santri", type: "select", options: STATUS_SANTRI_OPTIONS, group: "biodata" },
      { key: "status_pengabdian", label: "Status Pengabdian", type: "select", options: STATUS_PENGABDIAN_OPTIONS, group: "biodata" },
      { key: "lama_pengabdian", label: "Lama Pengabdian", type: "text", group: "biodata" },
      { key: "nama_pembimbing", label: "Nama Pembimbing Aktif/Terakhir", type: "pembimbing_select", group: "biodata" },
      { key: "jumlah_hafalan_terakhir", label: "Jumlah Hafalan Terakhir (Update)", type: "text", group: "biodata" },
      { key: "jenis_kelamin", label: "Jenis Kelamin", type: "select", options: JK_OPTIONS, group: "biodata" },
      { key: "tempat_lahir", label: "Tempat Lahir", type: "text", group: "biodata" },
      { key: "tanggal_lahir", label: "Tanggal Lahir", type: "date", group: "biodata" },
      { key: "alamat", label: "Alamat", type: "textarea", group: "biodata" },
      { key: "no_identitas", label: "No KTP/KK/SIM", type: "text", group: "biodata" },
      { key: "no_kontak_santri", label: "No Kontak Santri", type: "phone", group: "biodata" },
      { key: "pendidikan_terakhir", label: "Pendidikan Terakhir", type: "select", options: PENDIDIKAN_OPTIONS, group: "biodata" },
      { key: "sekolah_terakhir", label: "Nama Sekolah / Pendidikan Terakhir", type: "text", group: "biodata" },
      { key: "tahun_lulus", label: "Tahun Lulus", type: "year", group: "biodata" },
    ],
  },
  {
    id: "kesehatan",
    label: "Riwayat Kesehatan",
    fields: [
      { key: "penyakit_berat", label: "Penyakit Berat yang Pernah Diderita", type: "text", group: "kesehatan" },
      { key: "kondisi_penyakit", label: "Kondisi Penyakit", type: "select", options: KONDISI_PENYAKIT_OPTIONS, group: "kesehatan" },
      { key: "golongan_darah", label: "Golongan Darah", type: "select", options: GOL_DARAH_OPTIONS, group: "kesehatan" },
      { key: "alergi", label: "Alergi Obat / Makanan", type: "text", group: "kesehatan" },
    ],
  },
  {
    id: "potensi",
    label: "Potensi Santri",
    fields: [
      { key: "keahlian", label: "Keahlian", type: "text", group: "potensi" },
      { key: "karakter", label: "Karakter Diri yang Menonjol", type: "text", group: "potensi" },
      { key: "organisasi", label: "Nama Organisasi yang Pernah / Sedang Diikuti", type: "text", group: "potensi" },
      { key: "tokoh_kagum", label: "Tokoh Agama / Pergerakan yang Dikagumi", type: "text", group: "potensi" },
      { key: "hafalan_sebelum", label: "Jumlah Hafalan Al-Qur'an Sebelum Masuk GRQ", type: "text", group: "potensi" },
      { key: "hafalan_mutqin_sebelum", label: "Jumlah Hafalan Mutqin Sebelum Masuk GRQ", type: "text", group: "potensi" },
      { key: "tempat_belajar_sebelum", label: "Tempat Belajar Al-Qur'an Sebelumnya", type: "text", group: "potensi" },
      { key: "sumber_info_grq", label: "Darimana Mengetahui GRQ?", type: "text", group: "potensi" },
      { key: "alasan_mendaftar", label: "Alasan Mendaftar ke GRQ", type: "textarea", group: "potensi" },
    ],
  },
  {
    id: "ayah",
    label: "Biodata Ayah",
    fields: [
      { key: "nama_ayah", label: "Nama Lengkap Ayah", type: "text", group: "ayah" },
      { key: "tanggal_lahir_ayah", label: "Tanggal Lahir Ayah", type: "date", group: "ayah" },
      { key: "alamat_ayah", label: "Alamat Rumah Ayah", type: "textarea", group: "ayah",
        quickFill: [{ label: "Sama dengan data Santri", copyFrom: "alamat", literal: "Sama dengan data Santri" }] },
      { key: "pendidikan_ayah", label: "Pendidikan Terakhir Ayah", type: "select", options: PENDIDIKAN_OPTIONS, group: "ayah" },
      { key: "pekerjaan_ayah", label: "Pekerjaan Ayah", type: "text", group: "ayah" },
      { key: "pendapatan_ayah", label: "Pendapatan Ayah / Bulan", type: "currency", group: "ayah", hideFromSantri: true },
      { key: "no_kontak_ayah", label: "No HP Ayah", type: "phone", group: "ayah" },
    ],
  },
  {
    id: "ibu",
    label: "Biodata Ibu",
    fields: [
      { key: "nama_ibu", label: "Nama Lengkap Ibu", type: "text", group: "ibu" },
      { key: "tanggal_lahir_ibu", label: "Tanggal Lahir Ibu", type: "date", group: "ibu" },
      { key: "alamat_ibu", label: "Alamat Rumah Ibu", type: "textarea", group: "ibu",
        quickFill: [{ label: "Sama dengan data Santri", copyFrom: "alamat", literal: "Sama dengan data Santri" }] },
      { key: "pendidikan_ibu", label: "Pendidikan Terakhir Ibu", type: "select", options: PENDIDIKAN_OPTIONS, group: "ibu" },
      { key: "pekerjaan_ibu", label: "Pekerjaan Ibu", type: "text", group: "ibu" },
      { key: "pendapatan_ibu", label: "Pendapatan Ibu / Bulan", type: "currency", group: "ibu", hideFromSantri: true },
      { key: "no_kontak_ibu", label: "No HP Ibu", type: "phone", group: "ibu" },
    ],
  },
  {
    id: "wali",
    label: "Biodata Wali Santri",
    fields: [
      { key: "nama_wali", label: "Nama Lengkap Wali Santri", type: "text", group: "wali",
        quickFill: [
          { label: "Sama dengan Ayah", literal: "Sama dengan data Ayah" },
          { label: "Sama dengan Ibu", literal: "Sama dengan data Ibu" },
        ] },
      { key: "tanggal_lahir_wali", label: "Tanggal Lahir Wali", type: "date", group: "wali",
        quickFill: [
          { label: "Sama dengan Ayah", copyFrom: "tanggal_lahir_ayah" },
          { label: "Sama dengan Ibu", copyFrom: "tanggal_lahir_ibu" },
        ] },
      { key: "alamat_wali", label: "Alamat Rumah Wali", type: "textarea", group: "wali",
        quickFill: [
          { label: "Sama dengan Ayah", copyFrom: "alamat_ayah", literal: "Sama dengan data Ayah" },
          { label: "Sama dengan Ibu", copyFrom: "alamat_ibu", literal: "Sama dengan data Ibu" },
        ] },
      { key: "pendidikan_wali", label: "Pendidikan Terakhir Wali", type: "select", options: PENDIDIKAN_OPTIONS, group: "wali",
        quickFill: [
          { label: "Sama dengan Ayah", copyFrom: "pendidikan_ayah" },
          { label: "Sama dengan Ibu", copyFrom: "pendidikan_ibu" },
        ] },
      { key: "pekerjaan_wali", label: "Pekerjaan Wali", type: "text", group: "wali",
        quickFill: [
          { label: "Sama dengan Ayah", copyFrom: "pekerjaan_ayah" },
          { label: "Sama dengan Ibu", copyFrom: "pekerjaan_ibu" },
        ] },
      { key: "pendapatan_wali", label: "Pendapatan Wali / Bulan", type: "currency", group: "wali", hideFromSantri: true,
        quickFill: [
          { label: "Sama dengan Ayah", copyFrom: "pendapatan_ayah" },
          { label: "Sama dengan Ibu", copyFrom: "pendapatan_ibu" },
        ] },
      { key: "no_kontak_wali", label: "No HP Wali", type: "phone", group: "wali",
        quickFill: [
          { label: "Sama dengan Ayah", copyFrom: "no_kontak_ayah" },
          { label: "Sama dengan Ibu", copyFrom: "no_kontak_ibu" },
        ] },
    ],
  },
  {
    id: "media",
    label: "Profil (Media)",
    fields: [
      { key: "foto_profil", label: "Foto Profil (JPG/JPEG/PNG)", type: "image", group: "media" },
      { key: "link_youtube", label: "Link Profil YouTube", type: "text", group: "media",
        placeholder: "https://www.youtube.com/watch?v=..." },
    ],
  },
];

// Flat list of all fields (excluding username/password already special)
export const ALL_FIELDS = SEGMENTS.flatMap((s) => s.fields);

// Table columns for admin: mirror flat schema, keep numeric No first + Aksi last outside
export const TABLE_COLUMNS = [
  { key: "no", label: "No" },
  ...ALL_FIELDS.map((f) => ({
    key: f.key,
    label: f.label,
    type: f.type,
    isPassword: f.key === "password",
  })),
];

// Fields hidden from santri dashboard
export const SANTRI_HIDDEN_KEYS = ALL_FIELDS.filter((f) => f.hideFromSantri).map((f) => f.key);

// Formatting helpers
export function displayVal(v) {
  if (v === undefined || v === null) return "—";
  const s = String(v).trim();
  return s.length ? s : "—";
}

export function initialForType(type) {
  if (type === "phone") return "+62 ";
  if (type === "currency") return "Rp. ";
  return "";
}
